import { ProgressIndicator } from '@fluentui/react';
import { doc, onSnapshot } from 'firebase/firestore';

import RenderDialog from '../../../../addons/RenderDialog';
import { firestore } from '../../../../App/firebase';
import { getAsync } from '../../../../utils/api';

export default async (formId: string) => {
  const encodedFormId = encodeURIComponent(formId);
  const { data: formData, versionId } = await getAsync(
    `/forms/get?id=${encodedFormId}`
  );

  if (!formData.PDFDocumentId) {
    let closeModal: () => void;

    const removeListener = onSnapshot(
      doc(firestore, "forms_v2", formId, "versions", versionId),
      (snapshot) => {
        console.log(snapshot.data());
        if (snapshot.data()!.PDFDocumentId) {
          removeListener();
          closeModal();
          printForm(encodedFormId);
        }
      }
    );

    closeModal = RenderDialog({
      title: "PDF Oluşması Bekleniyor",
      subText:
        "Bu işlem birkaç dakika sürebilir. Sayfayı kapatmak bu işlemi etkilemez. Yazdırma işlemi için bekliyor...",
      showCloseButton: true,
      onClosed: removeListener,
      children: <ProgressIndicator />,
    });
  } else {
    printForm(encodedFormId);
  }
};

const printForm = async (encodedFormId: string) => {
  const pdfBlob: Blob = await getAsync("/forms/get-pdf?id=" + encodedFormId);

  const pdfUrl = URL.createObjectURL(pdfBlob);
  const iFrame = document.createElement("iframe");
  iFrame.src = pdfUrl;
  iFrame.style.display = "none";
  iFrame.onload = () => {
    setTimeout(() => {
      URL.revokeObjectURL(pdfUrl);
      iFrame?.remove();
    }, 5 * 60 * 1000);

    iFrame.contentWindow!.onafterprint = () => {
      iFrame.remove();
    };

    iFrame.contentWindow?.print();
  };
  document.body.append(iFrame);
};
